import React, { useRef } from 'react';
import SwiperCore, { A11y, Keyboard } from 'swiper';
import { Swiper as SwiperInstance, SwiperSlide } from 'swiper/react';
import ClientServiceStep from './ClientServiceStep';
import Icon from '@stone/ui/icon/Icon';
SwiperCore.use([Keyboard, A11y]);
const ClientServiceTracking = (props) => {
    var _a, _b;
    const swiperRef = useRef(null);
    const prevButton = useRef(null);
    const nextButton = useRef(null);
    const disableClass = 'swiper-button-disabled';
    const renderNavigation = () => (React.createElement("div", { className: "selector-navigation" },
        React.createElement("button", { ref: prevButton, className: `selector-prev-${props.componentid} selector-button ${disableClass}`, tabIndex: -1, onClick: () => {
                var _a;
                (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slidePrev();
            } },
            React.createElement(Icon, { family: "10", name: "left-chevron" })),
        React.createElement("button", { ref: nextButton, className: `selector-next-${props.componentid} selector-button`, tabIndex: -1, onClick: () => {
                var _a;
                (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slideNext();
            } },
            React.createElement(Icon, { family: "10", name: "right-chevron" }))));
    return (React.createElement(React.Fragment, null,
        ((_a = props.steps) === null || _a === void 0 ? void 0 : _a.length) > 1 && renderNavigation(),
        React.createElement(SwiperInstance, { onSwiper: (swiper) => (swiperRef.current = swiper), spaceBetween: 12, slidesPerView: 1.2, onSlideChange: (swiper) => {
                var _a, _b, _c, _d;
                if (swiper.isEnd) {
                    (_a = nextButton.current) === null || _a === void 0 ? void 0 : _a.classList.add(disableClass);
                }
                else {
                    (_b = nextButton.current) === null || _b === void 0 ? void 0 : _b.classList.remove(disableClass);
                }
                if (swiper.isBeginning) {
                    (_c = prevButton.current) === null || _c === void 0 ? void 0 : _c.classList.add(disableClass);
                }
                else {
                    (_d = prevButton.current) === null || _d === void 0 ? void 0 : _d.classList.remove(disableClass);
                }
            } }, (_b = props.steps) === null || _b === void 0 ? void 0 : _b.map((step, _k) => {
            return (React.createElement(SwiperSlide, { key: _k },
                React.createElement(ClientServiceStep, Object.assign({}, step, { isSlide: true }))));
        }))));
};
export default ClientServiceTracking;
